import { FC } from "react";
import { ListItem, ListItemButton, ListItemText, Stack } from "@mui/material";
import { AccountNavItemStats } from "./AccountNavItemStats";
import { getResourceTypeName } from "../../../../../../../../utils/helpers/resources/getResourceTypeName";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { resourceTypeDataEmsSelector } from "../../../../../../../../store/account/selectors/resource-type-data/resourceTypeDataEmsSelector";
import { resourceTypeDataSpendingSelector } from "../../../../../../../../store/account/selectors/resource-type-data/resourceTypeDataSpendingSelector";
import { ResourceType } from "../../../../../../../../services/cloudchipr.api";
import { useAccountPageNavigate } from "../../../utils/hooks/useAccountPageNavigate.hook";
import { TypographyWithTooltip } from "../../../../../../../common/TypographyWithTooltip";

interface AccountNestedNavItemProps {
  resourceType: ResourceType;
  selected?: boolean;
}

export const AccountNestedNavItem: FC<AccountNestedNavItemProps> = ({
  resourceType,
  selected,
}) => {
  const handleNavigationClick = useAccountPageNavigate(resourceType);

  const ems = useAppSelector((state) =>
    resourceTypeDataEmsSelector(state, resourceType),
  );

  const total = useAppSelector((state) =>
    resourceTypeDataSpendingSelector(state, resourceType),
  );

  return (
    <ListItem sx={listItemSx}>
      <ListItemButton
        sx={listItemButtonSx}
        selected={selected}
        onClick={handleNavigationClick}
      >
        <ListItemText
          inset
          sx={{ pl: 3 }}
          primary={
            <Stack direction="row" justifyContent="space-between" spacing={1}>
              <TypographyWithTooltip
                variant="subtitle2"
                title={getResourceTypeName(resourceType)}
                color={selected ? "primary" : "inherit"}
              />
              <AccountNavItemStats ems={ems} total={total} />
            </Stack>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};

const listItemSx = { px: 1, py: 0.25 };
const listItemButtonSx = { borderRadius: 2 };
